export default "__VITE_ASSET__BhBnLfK2__"